<header class="flex header">
  <h2>{{ 'Address_Detail_Modal_Title' | translateWF: 'Address Details' }}</h2>
  <p-button icon="pi pi-times" (click)="onClose()" />
</header>

<section class="content">
  <form [formGroup]="addressForm">
    <section class="flow">
      <!-- Type -->
      <div class="form-box">
        <label for="types">{{ 'Address_Detail_Modal_Types' | translateWF: 'Types' }}</label>
        <p-multiselect
          inputId="types"
          [options]="addressTypes"
          formControlName="addressTypes"
          optionLabel="label"
          optionValue="value"
          [placeholder]="'Address_Detail_Modal_Select_Type' | translateWF: 'Select Type'"
          class="w-full"
          (onChange)="onAddressTypeChange($event.value)"
        />
      </div>

      <!-- Address 1 -->
      <div class="form-box">
        <label for="address1">{{ 'Address_Detail_Modal_Address1' | translateWF: 'Address 1' }}</label>
        <input pInputText formControlName="address1" id="address1" class="w-full" />
      </div>

      <!-- Address 2 -->
      <div class="form-box">
        <label for="address2">{{ 'Address_Detail_Modal_Address2' | translateWF: 'Address 2' }}</label>
        <input pInputText formControlName="address2" id="address2" class="w-full" />
      </div>

      <!-- State / Province -->
      <div class="form-box">
        <label for="stateOrProvince">{{ 'Address_Detail_Modal_StateOrProvince' | translateWF: 'State / Province' }}</label>
        <input pInputText formControlName="stateOrProvince" id="stateOrProvince" class="w-full" />
      </div>

      <!-- Country -->
      <div class="form-box">
        <label for="country">{{ 'Address_Detail_Modal_Country' | translateWF: 'Country' }}</label>
        <p-dropdown
          inputId="country"
          formControlName="country"
          [options]="countries"
          [filter]="true"
          [virtualScroll]="true"
          [lazy]="true"
          (onFilter)="onCountrySearch($event.filter)"
          [placeholder]="'Address_Detail_Modal_Select_Country' | translateWF: 'Select Country'"
          class="w-full"
          optionLabel="label"
          optionValue="value"
        >
          <ng-template let-country pTemplate="item">
            <i class="pi pi-globe mr-2"></i>
            <span>{{ country.label }}</span>
          </ng-template>
        </p-dropdown>
      </div>

      <!-- City -->
      <div class="form-box">
        <label for="city">{{ 'Address_Detail_Modal_City' | translateWF: 'City' }}</label>
        <p-dropdown
          inputId="city"
          formControlName="city"
          [options]="cities"
          [filter]="true"
          [virtualScroll]="true"
          [lazy]="true"
          (onFilter)="onCitySearch($event.filter)"
          [placeholder]="'Address_Detail_Modal_Select_City' | translateWF: 'Select City'"
          class="w-full"
          optionLabel="label"
          optionValue="value"
        >
          <ng-template let-city pTemplate="item">
            <i class="pi pi-map-marker mr-2"></i>
            <span>{{ city.label }}</span>
          </ng-template>
        </p-dropdown>
      </div>

      <!-- ZIP Code -->
      <div class="form-box">
        <label for="zipCode">{{ 'Address_Detail_Modal_ZipCode' | translateWF: 'ZIP Code' }}</label>
        <input pInputText formControlName="zipCode" id="zipCode" class="w-full" />
      </div>
    </section>
  </form>
</section>

<footer>
  <p-button class="w-full" [label]="'Save' | translateWF: 'Save'" [disabled]="addressForm.invalid" (click)="onSave()" />
  <p-button class="w-full" [label]="'Cancel' | translateWF: 'Cancel'" variant="outlined" (click)="onClose()" />
</footer>
